import script from "./CabinetLeadsList.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetLeadsList.vue?vue&type=script&setup=true&lang=js"

import "./CabinetLeadsList.vue?vue&type=style&index=0&id=6cef0638&lang=css"

const __exports__ = script;

export default __exports__